import { useState, useEffect, useRef } from 'react';

const BASE_COUNT = 12847;
const STORAGE_KEY = 'djjean_visit_count';
const SESSION_KEY = 'djjean_session_counted';

export default function VisitorCounter() {
  const [count, setCount] = useState(BASE_COUNT);
  const [displayCount, setDisplayCount] = useState(0);
  const animationRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    // Recupera contagem salva ou usa a base
    const stored = localStorage.getItem(STORAGE_KEY);
    let currentCount = stored ? parseInt(stored, 10) : BASE_COUNT;

    // Conta somente uma vez por sessão
    const sessionCounted = sessionStorage.getItem(SESSION_KEY);
    if (!sessionCounted) {
      // Incremento aleatório entre 1 e 3 por sessão (simula múltiplos usuários)
      const increment = Math.floor(Math.random() * 3) + 1;
      currentCount += increment;
      localStorage.setItem(STORAGE_KEY, String(currentCount));
      sessionStorage.setItem(SESSION_KEY, 'true');
    }

    setCount(currentCount);
  }, []);

  // Animação do contador
  useEffect(() => {
    if (count === 0) return;
    const start = Math.max(0, count - 200);
    let current = start;
    const step = Math.ceil((count - start) / 60);

    const animate = () => {
      current = Math.min(current + step, count);
      setDisplayCount(current);
      if (current < count) {
        animationRef.current = setTimeout(animate, 20);
      }
    };

    animationRef.current = setTimeout(animate, 300);
    return () => {
      if (animationRef.current) clearTimeout(animationRef.current);
    };
  }, [count]);

  const formatted = displayCount.toLocaleString('pt-BR');

  return (
    <div className="flex items-center space-x-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3">
      <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
        <i className="ri-eye-line text-orange-400 text-base"></i>
      </div>
      <div>
        <p className="text-white font-bold text-lg leading-none tabular-nums">
          {formatted}
        </p>
        <p className="text-white/50 text-xs mt-0.5">visitas ao site</p>
      </div>
      <div className="flex items-center space-x-1 ml-2">
        <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></div>
        <span className="text-green-400 text-xs font-medium">online</span>
      </div>
    </div>
  );
}
